
import React from "react";
import {Fade } from "react-reveal";
import { HashLink } from 'react-router-hash-link';
import User from "../individual/User";
import StarRating from "../individual/StarRating";
import useAuth from "../../Hooks/useAuth";

const CollectinoItem = ({ perCollection }) => {
  const {showDummyImage} = useAuth()
  const {
    id,
    collImgOne,
    collImgTwo,
    collImgThree,
    collUser,
    collTitle,
    collValue,
    collReview,
    status,
  } = perCollection;
  return (
    <Fade bottom big duration={1500}>
      <div className="collection-item">
            <div className="collection-item-content">
                <HashLink to={`/profile/${id}/#header`}>
                  <div className="collection-item-top">
                      <div className="collection-img">
                        <img src={require(`${process.env.REACT_APP_COLLECTION_IMAGE}${collImgOne}`)}
                          alt={collImgOne}
                          onError={({currentTarget},imageSize='180X225')=>showDummyImage({currentTarget},imageSize)}
                        />
                      </div>
                      <div className="collection-img">
                        <img src={require(`${process.env.REACT_APP_COLLECTION_IMAGE}${collImgTwo}`)}
                          alt={collImgTwo}
                          onError={({currentTarget},imageSize='85X107')=>showDummyImage({currentTarget},imageSize)}
                        />
                      </div>
                      <div className="collection-img">
                        <img src={require(`${process.env.REACT_APP_COLLECTION_IMAGE}${collImgThree}`)}
                          alt={collImgThree}
                          onError={({currentTarget},imageSize='85X107')=>showDummyImage({currentTarget},imageSize)}
                        />
                      </div>
                  </div>
                </HashLink>
                <div className="collection-item-bottom">
                    <div className="collection-bottom-left">
                      <div className="collection-user">
                        <User
                          pic={require(`${process.env.REACT_APP_USER_IMAGE}${collUser}`)}
                          status={status}
                        />
                      </div>
                    </div>
                    <div className="collection-bottom-right">
                      <div className="collection-user-meta">
                        <h5>{collTitle}</h5>
                        <StarRating value={collReview}/>
                      </div>
                      <small>({collValue})</small>
                    </div>
                </div>
            </div>
      </div>
    </Fade>
  );
};

export default CollectinoItem;
